"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Vkiddm = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Vkiddm = function Vkiddm(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.56c0-4.978 0-7.467 1.546-9.014C3.093 0 5.582 0 10.56 0h.88c4.978 0 7.467 0 9.013 1.546C22 3.093 22 5.582 22 10.56v.88c0 4.978 0 7.467-1.547 9.013C18.907 22 16.418 22 11.44 22h-.88c-4.978 0-7.467 0-9.014-1.547C0 18.907 0 16.418 0 11.44v-.88zm3.667-3.838c.117 5.723 3.123 9.167 8.078 9.167h.287v-3.274c1.805.183 3.15 1.532 3.7 3.274h2.601c-.705-2.606-2.535-4.046-3.673-4.597 1.137-.68 2.745-2.33 3.124-4.57h-2.367c-.496 1.821-1.974 3.471-3.386 3.628V6.722H9.627v6.352c-1.464-.367-3.373-2.148-3.451-6.352h-2.51z",
    fill: "#fff"
  }));
};

exports.Vkiddm = Vkiddm;
var _default = Vkiddm;
exports.default = _default;